import { CreatedFilters } from "@/services/filters/filters";
import { IFilter } from "@/types";
import { getAffiliateSearch, getActiveUserSearch } from "@/api/user";
import { translatePartnerStatus } from "@/utils/translate";
import { filterClass } from "@/services/filters/filterClass";
import store from "@/store";

export class AccessesAdvertisersFilters extends CreatedFilters {
    user = store.getters['authModule/GET_USER'];
    constructor() {
        super();
    }

    clearFilters(): void {
        super.clearFilters();
        const params = { ...store.getters['GET_FILTERS_PARAMS_OBJECT'], affiliate_status: ['active'] };
        store.commit('SET_FILTERS_PARAMS_OBJECT', params);
        this.updateQueryString(params);
        const affiliateStatusFilter = this.filters.find((f) => f.id === 'affiliate_status');
        if (affiliateStatusFilter) {
            affiliateStatusFilter.select = ['active'];
        }
    }

    getActiveFiltersToSend(): any {
        const sentParams = super.getActiveFiltersToSend();
        const affiliateStatusFilter = this.filters.find((f) => f.id === 'affiliate_status');
        if (
            affiliateStatusFilter &&
            Array.isArray(affiliateStatusFilter.select) &&
            affiliateStatusFilter.select.length === 0
        ) {
            delete sentParams.affiliate_status;
        }
        return sentParams;
    }

    getFilters(): IFilter[] {
        const advertiser = store.getters['revenueModule/GET_CURRENT_ADVERTISER'];
        const isAdvertiser = advertiser && this.checkRoute('advertiser');
        return [
            new filterClass.Autocomplete({
                id: 'advertiser_id',
                label: 'Рекламодатель',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                defaultValue: isAdvertiser ? [advertiser] : [],
                items: [] as Array<{id: number, name: string}>,
                isHidden: true,
            }),
            new filterClass.Autocomplete({
                id: 'master_account_id',
                apiMethod: getAffiliateSearch,
                label: 'Мастер-аккаунт',
                itemValue: 'id',
                itemText: 'text',
                select: [],
                items: [],
                template: (i) => `${i.id} ${i.first_name} ${i.last_name} ${i.email}`,
                multiple: true,
                multiPaste: true,
            }),
            new filterClass.Autocomplete({
                id: 'affiliate_id',
                apiMethod: getAffiliateSearch,
                label: 'Партнёр',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                multiple: true,
                remove: true,
                multiPaste: true,
            }),
            new filterClass.Autocomplete({
                id: 'affiliate_manager_id',
                apiMethod: getActiveUserSearch,
                label: 'Менеджер партнёра',
                itemValue: 'id',
                itemText: 'name',
                select: [],
                items: [],
                multiple: true,
                multiPaste: true,
            }),
            new filterClass.Multiselect({
                id: 'affiliate_status',
                label: 'Статус',
                items: [{ id: 'active' }, { id: 'pending' }, { id: 'deleted' }, { id: 'blocked' }, { id: 'rejected' }],
                select: [],
                itemValue: 'id',
                template: ({ id }) => this.translateStatus(id, translatePartnerStatus),
                itemText: ({ id }) => this.translateStatus(id, translatePartnerStatus),
                multiple: true,
            }),

        ];
    }
}